export const ROLES = {
  '1': 'sheriff',
  '2': 'deputy',
  '3': 'renegade',
  '4': 'outlaw'
}